import { Component, Input, OnInit } from '@angular/core';
import { Profile } from '../../models/profile.model';
import { UserService } from '../../services/user.service';
import { getHospitalsNameBySelectedHospitals } from '../../utils/cross-functions';

@Component({
  selector: 'app-hospitals-hover',
  templateUrl: './hospitals-hover.component.html',
  styleUrls: ['./hospitals-hover.component.scss'],
  standalone: false,
})
export class HospitalsHoverComponent implements OnInit {
  @Input() public profile: Profile | undefined;

  @Input() public showHover: boolean = true;

  @Input() public isNight: boolean = false;

  public isMultiHospital: boolean = false;

  public isHovered: boolean = false;

  public hospitalsName: string[] = [];

  public fullHospitalsName: string = '';

  public isTooLong: boolean = false;

  constructor(private userService: UserService) {}

  ngOnInit() {
    if (this.profile && this.profile.hospitals) {
      const selectedHospitalsId = this.userService.getSelectedHospitals();
      this.isMultiHospital = selectedHospitalsId.length >= 2;
      this.hospitalsName = getHospitalsNameBySelectedHospitals(
        JSON.parse(JSON.stringify(this.profile)),
        this.profile.hospitals?.map((hospital) => (typeof hospital === 'string' ? hospital : hospital._id)),
        this.userService.usersHospitals ?? []
      );
      this.hospitalsName.forEach((name: string) => {
        if (this.fullHospitalsName.length > 0) {
          this.fullHospitalsName += ', ';
        }
        this.fullHospitalsName += name;
      });
      this.isTooLong = this.fullHospitalsName.length > 23;
    }
  }

  onMouseOver() {
    if (!this.showHover) {
      return;
    }
    this.isHovered = true;
    setTimeout(() => {
      this.isHovered = false;
    }, 3000);
  }

  onMouseOut() {
    this.isHovered = false;
  }
}
